export const VALID_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[\w-.]+(\.[a-z]{2,3})+/;
export const PERSONAL_EMAIL_DOMAIN_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(gmail|outlook|yahoo|aol|live|hotmail)(\.[a-z]{2,3})+/;
export const STUDENT_EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@((((student|std|stdn|leerling|ln)\.){1}[a-z]+)|([a-z]+(\.(student|std|stdn|leerling|ln)){1}))(\.[a-z]{2,3})+/;
